module.exports = new __parcel__URL__("background-light.e4dc0004.png").toString();